import { useMemo } from "react";

import { generateUrlArguments, timezone } from "@/utils";

import useForm from "@/hooks/useHookForm";
import useFormPayment from "@/hooks/useFormPayment";

import { useAppSelector } from "@/hooks/useRedux";

interface useOneOnOneYogaFormProps {
  setIsFormSubmitted?: (isFormSubmitted: boolean) => void;
}

const useOneOnOneYogaForm = ({
  setIsFormSubmitted = () => {},
}: useOneOnOneYogaFormProps) => {
  const { countryCodeData } = useAppSelector((state) => state.dashboard);
  const { data } = useAppSelector((state) => state.bootCamp);

  const countryCodeDefault = useMemo(
    () => countryCodeData?.default?.code || "+91",
    [countryCodeData]
  );

  const defaultValues = useMemo(
    () => ({
      name: "",
      email: "",
      mobileCountryCode: countryCodeDefault,
      mobile: "",
      referrerName: "",
      referrerMobileCountryCode: countryCodeDefault,
      referrerMobile: "",
    }),
    [countryCodeDefault]
  );

  const urlsArguments = generateUrlArguments();

  const { methods } = useForm({ defaultValues });

  const { isLoading, onBlur, onRequestCallback } = useFormPayment({
    methods,
    packData: data?.pricingData,
    urlsArguments,
    timezone,
  });

  const { handleSubmit } = methods;

  const requestCallbackHandler = handleSubmit((formValues) => {
    onRequestCallback(formValues).then(() => {
      setIsFormSubmitted(true);
    });
  });

  return {
    methods,
    isLoading,
    onBlur,
    requestCallbackHandler,
  };
};

export default useOneOnOneYogaForm;
